import React from 'react'
import { withRouter } from 'react-router-dom'
import { withAuthentication } from '../Session'
import { compose } from 'recompose'
import FormComponent from '../Form'
import { Container } from 'semantic-ui-react'
import { AutoHeader } from '../Common'
import templateForm from './config/template-form'

class TemplateCreatePage extends React.Component {
   render() {
      return (
         <Container>
            <AutoHeader />
            <Container>
               <FormComponent form={templateForm} {...this.props} />
            </Container>
         </Container>
      )
   }
}

export default compose(withRouter, withAuthentication)(TemplateCreatePage)
